import KeenSlider from 'keen-slider';

class ImageSlider {
  constructor(sliderEl, prevBtn, nextBtn, thumbnailEl, dotsEl) {
    this.sliderEl = sliderEl;
    this.prevBtn = prevBtn;
    this.nextBtn = nextBtn;
    this.thumbnailEl = thumbnailEl;
    this.dotsEl = dotsEl;

    this.init = this.init.bind(this);

    this.init();
  }

  init() {
    // eslint-disable-next-line no-new
    new KeenSlider(this.sliderEl, {
      loop: true,
      created: (instance) => {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => instance.prev());
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => instance.next());
        }

        if (this.thumbnailEl) {
          const thumbnails = this.thumbnailEl.querySelectorAll('.js-thumbnail');
          thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => instance.moveToSlideRelative(index));
          });
        }

        if (this.dotsEl) {
          const dots = this.dotsEl.querySelectorAll('.js-dot');
          dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              instance.moveToSlideRelative(index);
            });
          });
        }
      },
      slideChanged: (instance) => {
        if (this.dotsEl) {
          const dots = this.dotsEl.querySelectorAll('.js-dot');
          const index = instance.details().relativeSlide;

          dots.forEach((dot, dotIndex) => {
            if (dotIndex === index) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }
      },
    });
  }
}

export default ImageSlider;
